import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../global/hooks';
import { setActiveSectionId, setView } from '../../store/appSlice';
import { selectSectionIndexById } from '../../store/sectionsSlice';
import { Section } from '../../types';
import { SectionHeaderName, StyledSectionHeader } from './styles';

interface Props {
	section: Section;
}

export default function SectionHeader({ section }: Props) {
	const dispatch = useDispatch();
	const sectionIndex = useAppSelector(selectSectionIndexById(section.id));
	const handleEditSection = () => {
		dispatch(setActiveSectionId(section.id));
		dispatch(setView('editSection'));
	};

	return (
		<StyledSectionHeader>
			<SectionHeaderName onClick={handleEditSection}>
				<span>{section.name ? section.name : `Section ${sectionIndex + 1}`}</span>
			</SectionHeaderName>
		</StyledSectionHeader>
	);
}
